define('routers/AppRouter',[
    "backbone",
    "app",
    'lodash',
    'routers/routes'
], function (Backbone, App, _, routes) {

    "use strict";


    return Backbone.Router.extend({

        initialize: function () {
            // get origin
            var origin = window.location.origin;
            if (!origin) {
                // for ie
                origin = window.location.protocol + "//" +
                window.location.hostname +
                (window.location.port ? ':' + window.location.port: '');
            }

            // starting history API
            var root = App.siteURL.replace(origin, '');
            if (root.charAt(0) !== '/') {
                root = '/' + root;
            }
            Backbone.history.start({
                pushState: true,
                hashChange: false,
                root: root
            });
        },

        routes: routes,

        transition: true, // first rendering will have transition

        hrefToFragment: function (href) {
            return href.replace(App.siteURL, '').replace(/^\//, '');
        },

        goTo: function (href, transition) {
            var fragment = this.hrefToFragment(href);
            this.transition = transition || false;
            this.navigate(fragment, {trigger: true});
            this.transition = false;
        },

        /**
         * default route
         */
        notFound: function () {
            this.navigate('about', {trigger: true});
        },

        execute: function (callback, args) {
            if (!callback) {
                this.notFound();
            }

            // Backbone View
            if (callback.extend) {
                // route filter
                if (callback.filter) {
                    args = this[callback.filter].apply(this, args);
                    if (args === false) {
                        this.notFound();
                    }
                }

                // scroll to top of page
                window.scrollTo(0, 0);
                
                // render the view
                App.view.render(callback, this.transition, args);
            }
            // method callback
            else {
                callback.apply(this, args);
            }
        },

        match: function (href) {
            var fragment = this.hrefToFragment(href),
                result = null;

            _.every(routes, function (View, route) {
                var regex = this._routeToRegExp(route);
                if (fragment.match(regex) !== null) {

                    var args = this._extractParameters(regex, fragment);

                    /**
                     * route filter
                     */
                    if (View.filter) {
                        args.push(fragment);
                        args = this[View.filter].apply(this, args);
                    }

                    result = {
                        View: View,
                        args: args
                    };
                    return false;
                } else {
                    return true;
                }
            }, this);

            return result;
        },

        /**
         * Project route filter
         * @param  {String}     slug    Project slug
         * @return {Object}             Project object. Return false if project doesn't exist
         */
        project: function (slug, fragment) {
            fragment = fragment ? fragment : Backbone.history.fragment;
            var projects = fragment.match('case-studies') ? App.caseStudies : App.projects,
                project = _.find(projects, {slug: slug});

            return project ? [project] : false;
        }

    });

});
